import {ins as axios} from './plugin/axios'
export const toast = function (msg, {title, variant}) {
  this.$bvToast.toast(msg, {
    title: title || 'Success',
    variant: variant || 'success',
    toaster: 'b-toaster-top-left',
    solid: false,
    static: true
  })
}

export const projectStatusCheck = async ({surveyID}) => {
  try {
    const url = `/project/editable/${surveyID}`
    const method = `get`
    const {data} = await axios({
      url,
      method
    })
    const {editable, isOn, status} = data
    return {editable, isOn, status}
  } catch (e) {
    console.log(e)
    return false
  }
}



// WEBPACK FOOTER //
// ./src/mixin.js